import Link from 'next/link';
import { cn } from '@/lib/utils/cn';

/**
 * Prose link — brand colour, no underline, per .claude/config.md.
 *
 * This exists instead of a global `a { color: brand }` rule: that would also
 * repaint every sidebar row, table cell and button-rendered-as-anchor, since
 * all of them are `<a>`. Links opt in here.
 *
 * Renders next/link for internal hrefs and a plain anchor for external ones,
 * adding the rel guard automatically.
 */
export default function TextLink({ href = '', external, className, children, ...props }) {
  const isExternal = external ?? /^(https?:|mailto:|tel:)/.test(href);
  const Tag = isExternal ? 'a' : Link;

  return (
    <Tag
      href={href}
      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : null)}
      className={cn(
        'font-medium text-brand underline-offset-4 transition-colors hover:text-brand-strong hover:underline',
        className
      )}
      {...props}
    >
      {children}
    </Tag>
  );
}
